/**
 * 說明 : 樓層設定資料與後端API調用的非同步行為
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import BaseAPI from "./BaseAPI";

// 儲存樓層設定
export const saveFloor = createAsyncThunk(
    "floor/saveFloor",
    async (floor, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/elevMgmt/floor", floor, token);
            return data;
        } catch (err) {
            console.error('save floor error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得樓層設定列表
export const fetchFloorList = createAsyncThunk(
    "floor/fetchFloorList",
    async ({ elevatorId }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/elevMgmt/floor", { elevatorId: elevatorId}, token);
            return data;
        } catch (err) {
            console.error('fetch floor list error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得有效的樓層名稱選單
export const fetchFloorSelection = createAsyncThunk(
    "floor/fetchFloorSelection",
    async ({ elevatorId }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/selection/floor", { elevatorId: elevatorId}, token);
            return data;
        } catch (err) {
            console.error('fetch floor selection error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);